import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { TRIAL_TYPES } from 'utils/constants/trial';
import { useProviderSpecificConfiguration } from 'modules/appConfiguration/useProviderSpecificConfiguration';
import { HIDE_SOC_SINCE_SIGNUP_MS } from 'utils/constants/treatment';

export const shouldShowTreatments = ({
  disabledTrialTypes,
  registeredAt,
  treatments,
}) => {
  const treatmentsDisabled = (disabledTrialTypes ?? []).includes(TRIAL_TYPES.TREATMENT);
  if (!treatmentsDisabled) {
    return true;
  }

  const hasSponsoredTreatment = Array.isArray(treatments)
    ? treatments.some(({ isSponsored }) => isSponsored)
    : false;
  if (!hasSponsoredTreatment) {
    return false;
  }
  const registeredAtMs = Date.parse(registeredAt);
  if (Number.isNaN(registeredAtMs)) {
    return false;
  }
  const elapsed = Date.now() - registeredAtMs;
  return elapsed >= HIDE_SOC_SINCE_SIGNUP_MS;
};

export const shouldShowTrials = ({ disabledTrialTypes } = {}) => (
  !(disabledTrialTypes ?? []).includes(TRIAL_TYPES.TRIAL)
);

// @TODO: Not used for now
export const useShouldShowTreatments = (treatmentsOverride) => {
  const { disabledTrialTypes } = useProviderSpecificConfiguration();
  const { registeredAt, matchedTreatments } = useSelector((state) => ({
    registeredAt: state.profile.data?.personal?.registered_at,
    matchedTreatments: state.matches.treatments,
  }), shallowEqual);

  const treatments = treatmentsOverride ?? matchedTreatments;

  return useMemo(
    () => shouldShowTreatments({
      disabledTrialTypes,
      registeredAt,
      treatments,
    }),
    [disabledTrialTypes, registeredAt, treatments],
  );
};
